import { IBooleanSelectOption } from '../interfaces/IBooleanSelectOption';

export const booleanSelectOptions: IBooleanSelectOption[] = [
  {
    id: 0,
    label: 'Да',
    value: true,
  },
  {
    id: 1,
    label: 'Нет',
    value: false,
  },
];
